import axios from 'axios';

const api = axios.create({
  //baseURL: 'https://messages-images.cyclic.app',
  baseURL: 'https://api-rastreiafacil.brcintra.com',
});

export default api;
